<section class="cui-dialog">
  <header class="cui-dialog__header">
    <h1>
      {{ data.tool.name }} |
      {{ data.content === 'parameters' ? 'Parameters' : 'Run ' + data.toolJob.toolJobId }}
    </h1>
    <cui-dialog-close-button></cui-dialog-close-button>
  </header>
  <div class="cui-dialog__content">
    <app-tool-job-results
      [tool]="data.tool"
      [toolJob]="data.toolJob"
      [content]="data.content"></app-tool-job-results>
  </div>
</section>
